import { FormControl } from '@angular/forms';
import { RegistrationCodeField } from '../../models/appliance-details-stepped/registration-code-form-field.enum';
import { RegistrationCodeForm } from '../../models/appliance-details-stepped/registration-code-form.interface';

export const mockRegistrationCodeForm: RegistrationCodeForm = {
  [RegistrationCodeField.RegistrationCode]: new FormControl(null),
};
